
import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from
'@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import { ServiceWalkInModel } from '../model/index';

@Injectable()
export class ServiceWalkInService {
    private headers = new Headers({
        'Content-Type':
        'application/x-www-form-urlencoded', 'Accept':
        'q=0.8;application/json;q=0.9'
    });
    private serviceWalkInUrl = 'api/serviceWalkIn'; // URL to web api
    public  testingTrailUrl = 'api/testingTrail';
    
    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getServiceWalkInList(query: any): Promise<ServiceWalkInModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.serviceWalkInUrl}/getServiceWalkInList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getModelDetails(query: any): Promise<ServiceWalkInModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.serviceWalkInUrl}/getModelDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }



    getWalkInList(query: any): Promise<ServiceWalkInModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.serviceWalkInUrl}/getWalkInList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    addUpdateWalkIn(pageData: any): Promise<any> {
        const url = `${this.serviceWalkInUrl}/addUpdateWalkIn`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);

    }

    addSaveServiceWalkIn(pageData: any): Promise<any> {
        const url = `${this.serviceWalkInUrl}/addSaveServiceWalkIn`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);

    }

    addSaveServiceClient(pageData: any): Promise<any> {
        const url = `${this.serviceWalkInUrl}/addSaveServiceClient`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);

    }
     getServiceNoData(query: any): Promise<ServiceWalkInModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.serviceWalkInUrl}/getServiceNoDataList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    addServiceWalkIn(query: any): Promise<ServiceWalkInModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.serviceWalkInUrl}/addServiceWalkIn`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    addBillEntry(data: any): Promise<ServiceWalkInModel> {

        const url = `${this.serviceWalkInUrl}/addBillEntry`;

        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceWalkInModel)
            .catch(this.handleError);
    }
    addPrintStatus(data:any): Promise<any> {
        const url = `${this.serviceWalkInUrl}/addPrintStatus`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }
    getServiceModelDetails(data: any): Promise<ServiceWalkInModel> {

        const url = `${this.serviceWalkInUrl}/getServiceModelDetails`;

        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceWalkInModel)
            .catch(this.handleError);
    }

    deleteServiceWalkIn(walkInData: any): Promise<ServiceWalkInModel> {
        const url = `${this.serviceWalkInUrl}/deleteServiceWalkIn`;
        return this.http
            .post(url, $.param(walkInData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceWalkInModel)
            .catch(this.handleError);
    }

    deleteGridList(rowData: any): Promise<ServiceWalkInModel> {
        const url = `${this.serviceWalkInUrl}/deleteGridList`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceWalkInModel)
            .catch(this.handleError);
    }
    addSaveImportExport(data: any): Promise<ServiceWalkInModel> {

        const url = `${this.serviceWalkInUrl}/addExportImport`;

        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceWalkInModel)
            .catch(this.handleError);
    }

    saveServiceDetails(data: any): Promise<ServiceWalkInModel> {
        const url = `${this.testingTrailUrl}/addServiceEntry`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceWalkInModel)
            .catch(this.handleError);
    }

     saveManufactureIn(data: any): Promise<ServiceWalkInModel> {
        const url = `${this.testingTrailUrl}/addManufactureIn`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceWalkInModel)
            .catch(this.handleError);
    }

    serviceReply(data: any): Promise<any> {
        const url = `${this.serviceWalkInUrl}/addServiceReply`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<ServiceWalkInModel> {
        //console.error('An error occurred', error); // for demo
        //purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/serviceWalkIn.service.ts